export default __webpack_public_path__ + "static/media/Hand-wraps of the Spheres.8c4ae105.jpg";